// extracted by mini-css-extract-plugin
export var actionButton = "_kx-t";
export var buttonContainer = "_kx-0";
export var buttonContainer2 = "_kx-1";
export var buttonSection = "_kx-2";
export var details = "_kx-3";
export var dropdownItem = "_kx-5";
export var dropdownItemsContainer = "_kx-4";
export var fileInput = "_kx-r";
export var headerButton = "_kx-6";
export var icon = "_kx-7";
export var input = "_kx-8";
export var macroListItem = "_kx-9";
export var mainContent = "_kx-a";
export var microText = "_kx-b";
export var modal = "_kx-w";
export var optionsButton = "_kx-c";
export var paperclip = "_kx-s";
export var pillContent = "_kx-d";
export var preview = "_kx-e";
export var preview2 = "_kx-f";
export var quillEditor = "_kx-q";
export var selectedMacro = "_kx-g";
export var sidebar = "_kx-h";
export var sidebarHeader = "_kx-j";
export var sidebarList = "_kx-i";
export var sidebarListItem = "_kx-k";
export var sidebarSearch = "_kx-l";
export var snoozeDurationWrapper = "_kx-v";
export var statusPillContainer = "_kx-m";
export var tagsContainer = "_kx-n";
export var unselectedMacro = "_kx-o";
export var variable = "_kx-u";
export var wrapper = "_kx-p";